/**
 * A model of the HTTP response from the server after making a request.
 * Extends the response so that implementing a custom response object was easier.
 * Includes additional meta information about the request-response interaction itself.
 * Ideally this class would also contain information about the request itself but there is no need for that information now, so it can be added later.
 */
export class ClientResponse extends Response {
    public requestExecutionTimeMS = 0;
    public requestStartTimeMS = 0;
    public requestEndTimeMS = 0;

    public static fromResponse(response: Response, requestStartTimeMS: number, requestEndTimeMS: number): ClientResponse {
        const temp = response as ClientResponse;
        temp.requestExecutionTimeMS = requestEndTimeMS - requestStartTimeMS;
        temp.requestStartTimeMS = requestStartTimeMS;
        temp.requestEndTimeMS = requestEndTimeMS;
        return temp;
    }
}
